import Ajax from "@/api/ajax";
export default{
    //获取订单数量查询
    getorderCountV2(params) {
        return Ajax.post("/Home/orderCountV2", params);
    },
    //获取订单列表
    getorderListV2(params) {
        return Ajax.post("/Home/orderListV2", params);
    },
     //订单详情查询
    getorderDetailV2(params) {
        return Ajax.post("/Home/orderDetailV2", params);
    },
    //待支付-去支付
    payOrderV2(params) {
        return Ajax.post("/Home/payOrderV2", params);
    },
    //购物车支付
    cartGoodsListV2(params) {
        return Ajax.post("/Home/cartGoodsListV2", params);
    },
    //自提点列表
    getlistPickupPoints(params) {
        return Ajax.post("/Home/listPickupPoints", params);
    },
    //提交打包
    submitShipment(params) {
        return Ajax.post("/Home/submitShipment", params);
    },
    // 包裹列表
    packageListV2(params) {
        return Ajax.post("/Home/packageListV2", params);
    },
    // 包裹的数量查询
    packageCountV2(params) {
        return Ajax.post("/Home/packageCountV2", params);
    },
    // 支付运费
    payPackageV2(params) {
        return Ajax.post("/Home/payPackageV2", params);
    },

    // 包月卡列表
    getMonthlyCard(params) {
        return Ajax.post("/Home/getMonthlyCard", params);
    },
    // 包月卡支付
    purchaseMonthlyCard(params) {
        return Ajax.post("/Home/purchaseMonthlyCard", params);
    },
}